import { CalendarsActions, CalendarsActionTypes } from '../../actions/calendar-actions/calendars.actions';
import { Calendar } from '@cemex-core/cmx-api';

export interface CalendarsState {
  loading: boolean;
  calendars: Calendar[];
}

export const initialState: CalendarsState = {
  loading: false,
  calendars: [],
};

export function CalendarsReducer(state = initialState, action: CalendarsActions): CalendarsState {
  switch (action.type) {
    case CalendarsActionTypes.LOAD_CALENDARS_V2:
    case CalendarsActionTypes.LOAD_CALENDARS: {
      return {
        ...state,
        loading: true,
      } as CalendarsState;
    }
    case CalendarsActionTypes.LOAD_CALENDARS_COMPLETE: {
      return {
        ...state,
        loading: false,
        calendars: action.payload,
      } as CalendarsState;
    }
    case CalendarsActionTypes.LOAD_FAIL_CALENDARS: {
      return {
        ...state,
        loading: false,
        calendars: [],
      } as CalendarsState;
    }
    case CalendarsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
